// extracted by mini-css-extract-plugin
module.exports = {"loading":"VLProgressLoader_loading__1uBMr","percentage":"VLProgressLoader_percentage__Aw4i9"};